import Vue from 'vue'
import Router from 'vue-router'

import FullscreenLayout from './../components/Dashboard/Layout/FullscreenLayout.vue'

import ArtistsDirectory from '@/components/Dashboard/Views/Artists/Directory'
import ArtistProfile from '@/components/Dashboard/Views/Artists/ArtistProfile'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: FullscreenLayout,
      redirect: '/',
      children: [
        {
          path: '',
          name: 'ArtistsDirectory',
          component: ArtistsDirectory
        },
        {
          path: ':id',
          name: 'ArtistProfile',
          component: ArtistProfile
        }
      ]
    }
  ],
  // mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    console.log('scrollBehavior', savedPosition)
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js